const CHART_COLORS = [
  '#0288D1', // Blue
  '#7B1FA2', // Purple
  '#E91E63', // Pink
  '#FF5722', // Deep Orange
  '#4CAF50', // Green
  '#FF9800', // Orange
  '#00ACC1', // Cyan
  '#8BC34A', // Light Green
  '#F44336', // Red
  '#3F51B5', // Indigo
];

export { CHART_COLORS };
